import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  colors: {
    primary: "#636363",
    primaryHover: "#4f4f4f",
    secondary: "#a5a590",
    secondaryHover: "#8f8f7f",
    background: "#f9fafb",
    surface: "#ffffff",
    text: "#111827",
    muted: "#6b7280",
    border: "#e5e7eb",
    danger: "#dc2626",
    success: "#16a34a",
    heading: "#111827",
    subheading: "#374151",
    smallHeading: "#6b7280",
  },
  spacing: (n: number) => `${n * 8}px`,
  radius: {
    sm: "6px",
    md: "10px",
    lg: "16px",
  },
  shadow: {
    sm: "0 1px 2px rgba(0,0,0,0.05)",
    md: "0 4px 12px rgba(0,0,0,0.08)",
  },
};
